import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import React, { Fragment, useEffect, useRef, useState } from "react";
import { useMediaQuery } from "react-responsive";
import {
    getAccounts
} from "../homepurchase.service";
import { Loading } from "app/components";
import { useNavigate, useSearchParams } from "react-router-dom";
import { getSessionUserInformation } from "app/utils/utility.service";
import  { useReactToPrint } from "react-to-print";
import { formatNumber } from "app/utils/utility.service";
import { CATEGORIES_ASSETS } from "app/utils/Constants";
import { CATEGORIES_LIABILITIES } from "app/utils/Constants";


// Component to render the printable content
const ComponentToPrint = React.forwardRef(
    ({ categories, categoriesLiabilities, total, isDesktopOrLaptop }, ref) => {
        const grandTotalAssets = categories.reduce((acc, category) => {
            const total = category.subcategories?.reduce(
                (sum, sub) => sum + Number(sub.value || 0),
                0
            );
            return acc + total;
        }, 0);
        const grandTotalLiabilities = categoriesLiabilities.reduce(
            (acc, category) => {
                const total = category.subcategories?.reduce(
                    (sum, sub) => sum + Number(sub.value || 0),
                    0
                );
                return acc + total;
            },
            0
        );
        return (
            <div ref={ref} className="flex">
                <div className="col-6">
                    <div className="section-container">
                        <div className="section-header-balance ">
                            <span class="title" style={{ color: "#495057" }}>
                                Assets
                            </span>
                        </div>
                    </div>
                    {categories?.map((category, index) => {
                        console.log("categ "+JSON.stringify(categories[3].subcategories));
                        const total = category.subcategories?.reduce(
                            (sum, sub) => sum + Number(sub.value || 0),
                            0
                        );
                        return (
                            <Fragment>
                                <h4>{category.account_name}</h4>
                                {category.subcategories.map((sub, subIndex) => (
                                    
                                    <div key={sub.id} className="flex align-items-center ">
                                        <div className="col-3">
                                            <label>{sub.name}</label>
                                        </div>
                                        <div className="col-4">
                                            <InputText
                                                className="input-field  "
                                                style={{ width: "20rem" }}
                                                value={sub.value?"$ "+formatNumber(sub.value):""}
                                                disabled={true}
                                                thousandSeparator=","
                                                mode="currency"
                                                currency="USD"
                                            />
                                        </div>
                                    </div>
                                ))}
                                <div
                                    className="flex"
                                    style={{
                                        alignItems: "center",

                                    }}
                                >
                                    <div className="col-3">Total {category.account_name}</div>
                                    <div className="col-4">
                                        <InputText
                                            className="input-field"
                                            value={"$ " + formatNumber(total)}
                                            thousandSeparator=","
                                            style={{ width: "20rem" }}
                                            disabled={true}
                                            mode="currency"
                                            currency="USD"
                                            prefix="$ "
                                        />
                                    </div>
                                </div>


                            </Fragment>
                        );
                    })}
                    <div
                        className="flex "
                        style={{
                            alignItems: "center",
                            color: "#6c757d",
                            fontWeight: "600"
                        }}
                    >

                        <div className="col-3">Total Assets</div>
                        <div className="col-4">
                            <InputText
                                className="input-field  ml-1"
                                value={"$ " + formatNumber(grandTotalAssets)}
                                thousandSeparator=","
                                style={{ width: "20rem" }}
                                disabled={true}
                                mode="currency"
                                currency="USD"
                                prefix="$ "
                            />
                        </div>
                    </div>
                </div>
                <div className="col-6">
                    <div className="section-container">
                        <div className="section-header-balance">
                            <span class="title" style={{ color: "#495057" }}>
                                Liabilities
                            </span>
                        </div>
                    </div>
                    {categoriesLiabilities?.map((category, index) => {
                        const total = category.subcategories?.reduce(
                            (sum, sub) => sum + Number(sub.value || 0),
                            0
                        );
                        return (
                            <Fragment>
                                <h4>{category.account_name}</h4>
                                {category.subcategories.map((sub, subIndex) => (
                                    <div key={sub.id} className="flex align-items-center ">
                                        <div className="col-3">
                                            <label>{sub.name}</label>
                                        </div>
                                        <div className="col-4">
                                            <InputText
                                                className="input-field  "
                                                style={{ width: "20rem" }}
                                                value={sub.value?"$ "+formatNumber(sub.value):""}
                                                thousandSeparator=","
                                                mode="currency"
                                                currency="USD"
                                                disabled={true}
                                                prefix="$ "
                                            />
                                        </div>
                                    </div>
                                ))}
                                <div
                                    className="flex"
                                    style={{
                                        alignItems: "center",
                                     
                                    }}
                                >
                                    <div className="col-3">Total {category.account_name}</div>
                                    <div className="col-4">
                                        <InputText
                                            className="input-field"
                                            value={"$ " + formatNumber(total)}
                                            thousandSeparator=","
                                            style={{ width: "20rem" }}
                                            disabled={true}
                                            mode="currency"
                                            currency="USD"
                                            prefix="$ "
                                        />
                                    </div>
                                </div>

                            </Fragment>
                        );
                    })}
                    
                    <div
                        className="flex "
                        style={{
                            alignItems: "center",
                            color: "#6c757d",
                            fontWeight: "600"
                        }}
                    >
                        <div className="col-3">Total Liabilities</div>
                        <div className="col-4">
                            <InputText
                                className="input-field  ml-1"
                                value={"$ " + formatNumber(grandTotalLiabilities)}
                                thousandSeparator=","
                                style={{ width: "20rem" }}
                                disabled={true}
                                mode="currency"
                                currency="USD"
                                prefix="$ "
                            />
                        </div>
                    </div>
                    <div
                        className="flex "
                        style={{
                            alignItems: "center",
                            color: "#6c757d",
                            fontWeight: "600"
                        }}
                    >

                        <div className="col-3">Current Net Worth</div>
                        <div className="col-4">
                            <InputText
                                className="input-field  ml-1"
                                value={"$ " + formatNumber(grandTotalAssets-grandTotalLiabilities)}
                                thousandSeparator=","
                                style={{ width: "20rem" }}
                                disabled={true}
                                mode="currency"
                                currency="USD"
                                prefix="$ "
                            />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
);

const BalanceSheetReport = () => {

    const navigate = useNavigate();

    const [isLoading, setIsLoading] = useState(false);

    let componentRef = useRef(null);
    const promiseResolveRef = useRef(null);
    const [searchParams] = useSearchParams();
    const [isPrinting, setIsPrinting] = useState(false);
    const sessionValues = getSessionUserInformation();
    const clientId = searchParams.get("clientid");
    const userId = clientId && clientId !== "null" ? clientId : sessionValues.id;
    const isDesktopOrLaptop = useMediaQuery({
        query: "(min-width: 1224px)",
    });
    const [categories, setCategories] = useState(CATEGORIES_ASSETS);
      const [categoriesLiabilities, setCategoriesLiabilities] = useState(CATEGORIES_LIABILITIES);
   /* const [categories, setCategories] = useState([
        {
            categoryId: 1,
            account_name: "Cash & Cash Equivalents",
            isStatic: true,
            subcategories: [
                { name: "Cash on hand", value: null, isStatic: true },
                { name: "Checking accounts", value: null, isStatic: true },
                { name: "Savings accounts", value: null, isStatic: true },
                { name: "Money markets", value: null, isStatic: true },
                {
                    name: "Certificates of Deposit",
                    value: null,
                    isStatic: true,
                },
                { name: "Other", value: null, isStatic: true },
            ],
        },
        {
            categoryId: 2,
            account_name: "Brokerage Accounts",
            isStatic: true,
            subcategories: [
                { name: "Stocks", value: null, isStatic: true },
                { name: "Mutual Funds", value: null, isStatic: true },
                { name: "Municipal Bonds", value: null, isStatic: true },
                { name: "Government bonds", value: null, isStatic: true },
                { name: "Corporate bonds", value: null, isStatic: true },
                { name: "Other 1", value: null, isStatic: true },
                { name: "Other 2", value: null, isStatic: true },
            ],
        },
        {
            categoryId: 3,
            account_name: "Retirement Accounts",
            isStatic: true,
            subcategories: [
                { name: "401(k)", value: null, isStatic: true },
                { name: "IRA - Roth", value: null, isStatic: true },
                { name: "IRA - Traditional", value: null, isStatic: true },
                { name: "Profit Sharing", value: null, isStatic: true },
                { name: "Pension", value: null, isStatic: true },
            ],
        },
        {
            categoryId: 4,
            account_name: "Property",
            isStatic: true,
            subcategories: [
                { name: "Primary residence", value: null, isStatic: true },
               
            ],
        },
        {
            categoryId: 5,
            account_name: "Other Assets",
            isStatic: true,
            subcategories: [
                {
                    name: "Loans to friends/family",
                    value: null,
                    isStatic: true,
                },
                {
                    name: "Life insurance cash surrender value",
                    value: null,
                    isStatic: true,
                },
                { name: "Jewelry", value: null, isStatic: true },
                { name: "Furnishings", value: null, isStatic: true },
                { name: "Antiques", value: null, isStatic: true },
                { name: "Collectables", value: null, isStatic: true },
                { name: "Other 1", value: null, isStatic: true },
                { name: "Other 2", value: null, isStatic: true },
            ],
        },
    ]);
    const [categoriesLiabilities, setCategoriesLiabilities] = useState([
        {
            categoryId: 1,
            account_name: "Short-Term Credit",
            isStatic: true,
            subcategories: [
                { name: "Credit card 1", value: null, isStatic: true },
                { name: "Credit card 2", value: null, isStatic: true },
                { name: "Credit card 3", value: null, isStatic: true },
                { name: "Loans from friends/family", value: null, isStatic: true },
                { name: "Home line of credit", value: null, isStatic: true },
            ],
        },
        {
            categoryId: 2,
            account_name: "Loans & Mortgages",
            isStatic: true,
            subcategories: [
                { name: "Primary residence", value: null, isStatic: true },
              
            ],
        },
        {
            categoryId: 3,
            account_name: "Other Liabilities",
            isStatic: true,
            subcategories: [
                { name: "Commitment to donate", value: null, isStatic: true },
            ],
        },
    ]);*/
    useEffect(() => {
        setIsLoading(true);

        fetchAccounts();
        if (isPrinting && promiseResolveRef.current) {
            // Resolves the Promise, letting `react-to-print` know that the DOM updates are completed
            promiseResolveRef.current();
        }
    }, [isPrinting]);
    const fetchAccounts = async () => {
        let apiData = await getAccounts(userId);
        const groupedByType = apiData.reduce((acc, item) => {
            const type = item.type || "Unknown"; // Fallback for empty types
            if (!acc[type]) {
                acc[type] = [];
            }
            acc[type].push(item);
            return acc;
        }, {});
        // Create a map of static categories for quick lookup
        const staticMap = new Map(
            categories.map((cat) => [cat.account_name, { ...cat }])
        );

        // Iterate over API categories
        groupedByType["Assets"]?.forEach((apiCat) => {
            const existingCat = staticMap.get(apiCat.account_name);

            if (existingCat) {
                existingCat.account_id = apiCat.id;
                // Map existing subcategories by name for quick access
                const subMap = new Map(
                    existingCat.subcategories.map((sub) => [sub.name, { ...sub }])
                );

                // Update or add subcategories
                apiCat.accountCategories.forEach((apiSub) => {
                    const sub = subMap.get(apiSub.name);
                    if (sub) {
                        sub.value = Number(apiSub.value);
                        sub.id = apiSub.id;
                        //sub.isStatic = true;
                    } else {
                        subMap.set(apiSub.name, {
                            id: apiSub.id, // Use actual ID if available
                            name: apiSub.name,
                            value: Number(apiSub.value),
                            isStatic: false,
                        });
                    }
                });

                // Update subcategories in the map
                existingCat.subcategories = Array.from(subMap.values());
                staticMap.set(apiCat.account_name, existingCat);
            } else {
                // New category from API
                staticMap.set(apiCat.account_name, {
                    categoryId: apiCat.id,
                    account_name: apiCat.account_name,
                    account_id: apiCat.id,
                    subcategories: apiCat.accountCategories.map((sub) => ({
                        id: sub.id,
                        name: sub.name,
                        value: Number(sub.value),
                        isStatic: false,
                    })),
                });
            }
        });

        // Set merged result
        setCategories(Array.from(staticMap.values()));

        const staticMapLiabilities = new Map(
            categoriesLiabilities.map((cat) => [cat.account_name, { ...cat }])
        );
        groupedByType["Liabilities"]?.forEach((apiCat) => {
            const existingCat = staticMapLiabilities.get(apiCat.account_name);

            if (existingCat) {
                existingCat.account_id = apiCat.id;
                // Map existing subcategories by name for quick access
                const subMap = new Map(
                    existingCat.subcategories.map((sub) => [sub.name, { ...sub }])
                );

                // Update or add subcategories
                apiCat.accountCategories.forEach((apiSub) => {
                    const sub = subMap.get(apiSub.name);
                    if (sub) {
                        sub.value = Number(apiSub.value);
                        sub.id = apiSub.id;
                        //sub.isStatic = true;
                    } else {
                        subMap.set(apiSub.name, {
                            id: apiSub.id, // Use actual ID if available
                            name: apiSub.name,
                            value: Number(apiSub.value),
                            isStatic: false,
                        });
                    }
                });

                // Update subcategories in the map
                existingCat.subcategories = Array.from(subMap.values());
                staticMapLiabilities.set(apiCat.account_name, existingCat);
            } else {
                // New category from API
                staticMapLiabilities.set(apiCat.account_name, {
                    categoryId: apiCat.id,
                    account_name: apiCat.account_name,
                    account_id: apiCat.id,
                    subcategories: apiCat.accountCategories.map((sub) => ({
                        id: sub.id,
                        name: sub.name,
                        value: Number(sub.value),
                        isStatic: false,
                    })),
                });
            }
        });
        setCategoriesLiabilities(Array.from(staticMapLiabilities.values()));
        setIsLoading(false);
    };

    const handlePrint = useReactToPrint({
        content: () => componentRef.current,
        documentTitle: "Breakdown Maintenance Report",
    });

    return (
        <div>
            {isLoading && <Loading />}
            <div className="Accounts">
                <div className="grid">
                    <div className="bannerStyle col-12 mb-4 mt-2"  style={{textAlign:"start"}}>Balance Sheet Report</div>
                </div>
                <div>
                    {/* Report Data */}

                    {/* component to be printed */}
                    <ComponentToPrint
                        categories={categories}
                        categoriesLiabilities={categoriesLiabilities}
                        isDesktopOrLaptop={isDesktopOrLaptop}
                        //  total={total}
                        ref={componentRef}
                    />
                </div>
            </div>
            {/* Buttons */}
            <div style={{ margin: "2rem", textAlign: "end" }}>
                <Button
                    label="Print Report"
                    className="p-button-raised p-button-warning mr-2"
                    onClick={handlePrint}
                />
                <Button
                    label="Cancel"
                    className="p-button-raised p-button"
                    onClick={() => navigate(-1)}
                />
                <div></div>
            </div>
        </div>
    );
};
export default BalanceSheetReport;
